import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelComponent } from './hotel.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { HotelsModule } from '../../hotels/hotels.module';
import { DaProgressiveImageModule } from '../../da-progressive-image';

@NgModule({
    declarations: [HotelComponent],
    exports: [HotelComponent],
    imports: [
        CommonModule,
        RouterModule,
        HotelsModule,
        DaProgressiveImageModule,
        TranslateModule.forChild(),
        LocalizeRouterModule.forChild([])
    ],
    providers: []
})
export class HotelModule {}
